import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import { getMe, logoutUser } from '../services/auth';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    try {
      const { data } = await getMe();
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadUser(); }, [loadUser]);

  const login = useCallback((userData) => {
    setUser(userData);
  }, []);

  const logout = useCallback(async () => {
    try {
      await logoutUser();
    } catch {
      // Ignorer les erreurs reseau — le serveur supprime le cookie
    }
    setUser(null);
  }, []);

  // Le superadmin dispose de toutes les prerogatives d'un admin, et de plus.
  const isSuperAdmin = user?.role === 'superadmin';
  const isAdmin = user?.role === 'admin' || isSuperAdmin;

  const value = useMemo(
    () => ({ user, loading, login, logout, isAdmin, isSuperAdmin, loadUser }),
    [user, loading, login, logout, isAdmin, isSuperAdmin, loadUser]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
